import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { BLOCKS } from "@contentful/rich-text-types"
import { camelize } from "../functions/utils"

const renderOptions = {
    renderNode: {
        [BLOCKS.EMBEDDED_ASSET]: (node) => {
            const fields = node.data.target.fields
            if (!fields) return null
            const { url, title, description } = fields.file
            return (
                <div className="embedded-asset" style={{ marginTop: 20 }}>
                    <img src={url} alt={description || title} />
                    {description && <p>{description}</p>}
                </div>
            )
        },
    },
}

const News = ({ data }) => {
    if (!data) return
    return (
        <div id={camelize(data.title)}>
            <h4 className="content_h4">{data.title}</h4>
            {data.content ? documentToReactComponents(data.content, renderOptions) : null}
        </div>
    )
}

export default News